module.exports = __webpack_public_path__ + "static/media/slide_11.dfebff74.jpg";